import { IRepository, ICommit, IEntityUser } from '@/types';

import * as Styled from './styled';
import Link from 'next/link';

import Tag from '@/ui/Tag';
import { UserAvatar } from '@/components/Avatar';
import emojify from '@/lib/emojify';
import { toTimeAgo } from '@/lib/dateTime';
import { Row, Stack } from '@/ui/primatives';
import Button from '@/ui/Button';
import { Link1Icon, Link2Icon, CodeIcon } from '@radix-ui/react-icons';
import * as Icon from '@/ui/Icon';

const Commit: React.FC<{
  repository: IRepository;
  commit: ICommit;
  resourcePath?: string;
  resourceType?: 'dir' | 'file';
  stretch?: boolean;
}> = ({ repository, commit, resourcePath, resourceType, stretch }) => {
  // TODO: remove this once EntityUsers are added to the commit object
  const user: IEntityUser = {
    id: 'todo',
    username: commit.author,
    name: commit.author,
    email: commit.email,
    image: undefined,
  };

  return (
    <Styled.Commit stretch={stretch}>
      <Row alignItems="center" gap={10} justifyContent="space-between">
        <Stack gap={10}>
          <Styled.CommitMessage>
            <Link href={`/${repository.namespace}/${repository.name}/commit/${commit.id}`}>
              {emojify(commit.message)}
            </Link>
          </Styled.CommitMessage>
          <Styled.User>
            <UserAvatar user={user} size={20} />
            <div>
              <b>{commit.author || 'unknown'}</b>
              <Styled.Timestamp>{`committed ${toTimeAgo(commit.timestamp)}`}</Styled.Timestamp>
            </div>
          </Styled.User>
        </Stack>

        <Stack gap={10} alignItems="flex-end">
          <Link
            href={`/${repository.namespace}/${repository.name}/commit/${commit.id}`}
            style={{ flex: 0, width: 'auto' }}
          >
            <Row gap={10} alignItems="center">
              <Tag variant="subtle">#{commit.id}</Tag> <Link2Icon />
            </Row>
            {/* <Icon.Server />
            <CodeIcon />
            <Icon.FolderOpen /> */}
          </Link>
          <Row gap={10} style={{ flex: 0, width: 'auto' }}>
            {resourcePath && (
              <Button.Basic
                small
                href={`/${repository.namespace}/${repository.name}/${resourceType}/${commit.id}/${resourcePath}`}
              >
                Resource at commit
              </Button.Basic>
            )}
          </Row>
        </Stack>
      </Row>
    </Styled.Commit>
  );
};

export default Commit;
